import { render } from "./OrderDialog.vue?vue&type=template&id=67aca009"
import script from "./OrderDialog.vue?vue&type=script&lang=js"
export * from "./OrderDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WorkSpace\\Codes\\website-apps\\frontend\\report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__